import { render, staticRenderFns } from "./TripSearch.vue?vue&type=template&id=50582256&scoped=true&"
import script from "./TripSearch.vue?vue&type=script&lang=js&"
export * from "./TripSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50582256",
  null
  
)

export default component.exports